import $ from 'jquery';
import React, { Fragment } from 'react';
import { slide as Menu } from 'react-burger-menu';
import ReactHtmlParser from 'react-html-parser';
import { BrowserRouter as Router, Link, Redirect, Route, Switch } from "react-router-dom";
import plpSigninIcon from '../../images/icons/plp_signin_icon.png';
import schoolSigninIcon from '../../images/icons/school_signin_icon.png';
import pwdhelpscrn from '../../images/pwdhelpscrn.png';
import HmEventRegistry from '../../model/HmEventRegistry';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import HmAjax from '../../util/HmAjax';
import NativeAjax from '../../util/NativeAjax';
import ErrorPage from '../../views/core/ErrorPage';
import PreLoginPage from '../../views/core/PreLoginPage';
import Dashboard from '../../views/dashboard/Dashboard';
import Contactus from '../../views/login/Contactus';
import TchrContactus from '../../views/login/TchrContactus';
import CreateNewAccountForm from '../../views/login/CreateNewAccountForm';
import ForgotPasswordForm from '../../views/login/ForgotPasswordForm';
import ForgotPwd from '../../views/login/ForgotPwd';
import UnifiedForgotPwd from '../../views/login/UnifiedForgotPwd';
import LoginForm from '../../views/login/LoginForm';
import LumosLoginForm from '../../views/login/LumosLoginForm';
import UnifiedLogin from '../../views/login/UnifiedLogin';
import SignupForm from '../../views/login/SignupForm';
import Home from '../../views/plp/Home';
import TestTakingModalComponent from '../../views/plp/TestTakingModalComponent';
import BillingDetails from '../../views/purchase/BillingDetails';
import MyProducts from '../../views/purchase/MyProducts';
import Scorecard from '../../views/scorecard/Scorecard';
import Settings from '../../views/settings/Settings';
import '../public/css/all-css.css';
import '../public/css/main.css';
import '../public/css/wrapper.css';
import '../public/css/seo-optimize.css';
import './App.css';

/*import Banner from './components/Banner.js';*/
/*import SignupSection from './components/SignupSection.js';*/
import Use from './components/Use.js';
/*import WhoBanner from './components/WhoBanner.js';*/
/*import LessonFeatures from './components/LessonFeatures';*/
/*
* IMPORTANT: To revert back to the older way of showing products on home,
* uncomment the above lines and comment the below ones.
*/
import Banner from './components/Banner2.js';
import SignupSection from './components/SignupSection2.js';
/*import Use from './components/Use2.js';*/
import WhoBanner from './components/WhoBanner2.js';
import LessonFeatures from './components/LessonFeatures2.js';

import StaticFeed from './components/StaticFeed';
import RecognisedStatic from './components/RecognisedStatic';

import EndorsedStatic from './components/EndorsedStatic';
import ProgramHighlights from './components/ProgramHighlights';
import NrichCollaboration from './components/NrichCollaboration';
import TeacherResources from './components/TeacherResources';
import Blog from './components/Blog.js';
import Spotlight from './components/Spotlight';
import OverallFeatures from './components/OverallFeatures';
import DownloadButton from './components/DownloadButton';
import BuyOption from './components/BuyOption.js';
import Culture from './components/Culture.js';
import DayInLife from './components/DayInLife.js';
import Experience from './components/Experience.js';
import Featured from './components/Featured.js';
import FlipSection from './components/FlipSection.js';
import Footer from './components/Footer.js';
import Founders from './components/Founders.js';
import FounderVideos from './components/FounderVideos.js';
import Grades from './components/Grades.js';
import HowWorks from './components/HowWorks.js';
import Lessons from './components/Lessons.js';
import OtherLearnings from './components/OtherLearnings.js';
import OurTeachers from './components/OurTeachers.js';
import OurParents from './components/OurParents.js';
import ContactHeader from './components/ContactHeader.js';
import OurTeam from './components/OurTeam.js';
import PageBanner from './components/PageBanner.js';
import PageBannerBuy from './components/PageBannerBuy.js';
import ProductBanner from './components/ProductBanner.js';
import Recognised from './components/Recognised.js';
import ScrollToTopOnMount from './components/ScrollToTopOnMount.js';
import Testimonial from './components/Testimonial.js';
import TeacherBannerBuy from './components/TeacherBannerBuy.js';
import TeacherBuy from './components/TeacherBuy.js';
import OurTestimonial from './components/OurTestimonial.js';
import TeacherTestimonial from './components/TeacherTestimonial.js';
import Topics from './components/Topics.js';
import Trusted from './components/Trusted.js';
import Why from './components/Why.js';

import ProductMenu from './components/ProductMenu';
import FAQ from './components/FAQ';
import BrowserUtil from '../../util/BrowserUtil';

import TeacherProdComp from  './components/TeacherProdComp';
import ComponentRegistry from '../../model/ComponentRegistry';
import Report from '../../vendors/mindstretcher/Report';

import SGProductCatalogue from './../../views/others/SGProductCatalogue';
import NewINProductCatalogue from './../../views/others/NewINProductCatalogue';
import TopBanner from './../../views/others/TopBanner';
import InTopBanner from './../../views/others/InTopBanner';


import SGTeacherBuy from './components/SGTeacherBuy';

let maintenanceMessage = (window.maintenanceMessage) ? window.maintenanceMessage : {};


class PreloginHome extends PreLoginPage {

	constructor(props) {
		super(props);

		var urlSplitArray = document.location.pathname.split("/");

		this.state = {
			grades: [],
			classes: {},
			products_details: {},
			products_class: {},
			products_classification: {},
			products_category: {},
			products_category_order:[],
			menuOpen: false,
			isOpen:false,
			HelpModalShow:false,
			HelpModalContent:"",
			"ModalShow":false,
			"ModalContent":"",
			"ModalHeader":"",
			PLPloggedIn:false,
			LumosloggedIn:false,
			loggedIn:false,
			productsJson:null,
			selectedGrade:null,
			selectedTarriffID:null,
			purchaseKey:"PLP_USER_PURCHASE",
			customClass:"",
			userRole:"",
			navigationKey:"PLP_Navigation",
			productsInfoAvailable: (localStorage.getItem('product') === urlSplitArray[urlSplitArray.length-1]) ? true : false,
			productsLoadErr:false,
			loginStoreKey:"PLP_LOGIN_INFO",		
			userName:"",
			preloginClassName:"PreLogin",
			imagePreviewUrl:"",
			imageLoaded:false,
			userProdReqComplete:false,
			triedFree:false,
			purchased:false,
			loginRequestComplete:false,
			InfoModalHeader:'',
			InfoModalShow:false,
			InfoModalContent:"",
			catalogProdType: "SPL"
		}
		this.showLoginForm = this.showLoginForm.bind(this);		
		this.hideLoginModal = this.hideLoginModal.bind(this);
		this.hideHelpLoginModal = this.hideHelpLoginModal.bind(this);
		this.hideInfoModal =  this.hideInfoModal.bind(this);
	//this.loginIframeLoaded = this.loginIframeLoaded.bind(this);
	//this.pwdIframeLoaded = this.pwdIframeLoaded.bind(this);
	this.loginIframeView = null;
	this.pwdIframeView = null;	
	this.selectedMenu = null;

	this.suppressedHeaders = [];
	this.showSubscriptionForm = this.showSubscriptionForm.bind(this);
	
	this.showForgotPasswordForm = this.showForgotPasswordForm.bind(this);
	this.showSuccessForgotPwdMessage = this.showSuccessForgotPwdMessage.bind(this);
	this.showSuccessContactMessage = this.showSuccessContactMessage.bind(this);
	this.showsuccessRegisterMsg = this.showsuccessRegisterMsg.bind(this);
	this.getLoginForm = this.getLoginForm.bind(this);
	this.getLiveFeedLoginForm = this.getLiveFeedLoginForm.bind(this);
	this.showLiveFeedLogin = this.showLiveFeedLogin.bind(this);
	
	this.showCreateAccount = this.showCreateAccount.bind(this);
	this.startFreeTrial = this.startFreeTrial.bind(this);
	this.showForgotHelpScreen = this.showForgotHelpScreen.bind(this);
	this.showContactus = this.showContactus.bind(this);
	this.showContactusForTeacher = this.showContactusForTeacher.bind(this);
	this.showSignUp = this.showSignUp.bind(this);
	
	this.showSubScripeLoginForm = this.showSubScripeLoginForm.bind(this);
	this.getSubScripeLoginForm = this.getSubScripeLoginForm.bind(this);
	this.getSingleLoginForm = this.getSingleLoginForm.bind(this);
	this.onLogout = this.onLogout.bind(this);
	this.doLogout = this.doLogout.bind(this);
	this.menuSelected = this.menuSelected.bind(this);
	this.Home = this.Home.bind(this);
	this.Products = this.Products.bind(this);
	this.SelfPaced = this.SelfPaced.bind(this);
	this.Plp = this.Plp.bind(this);
	this.cbse = this.cbse.bind(this);
	this.Learnings = this.Learnings.bind(this);
	this.WhoWeAre = this.WhoWeAre.bind(this);
	this.Blog = this.Blog.bind(this);
	this.Spotlight = this.Spotlight.bind(this);
	this.Faq = this.Faq.bind(this);
	this.Teachers = this.Teachers.bind(this);
	this.getBannerContent = this.getBannerContent.bind(this);
	this.closeBanner = this.closeBanner.bind(this);
	this.showNewLoginForm = this.showNewLoginForm.bind(this);
	this.UpdateProfileImage = this.UpdateProfileImage.bind(this);
	this.userNameUpdateEvent = this.userNameUpdateEvent.bind(this);
	this.doPLPLogout = this.doPLPLogout.bind(this);
	this.doLumosLogout = this.doLumosLogout.bind(this);
	this.doCommonLogout = this.doCommonLogout.bind(this);
	this.gaFrom = "";
	
	this.isProdcutLoadCalled = false;
	this.modalcloseDataGA = "";

	//this.renderClassView = this.renderClassView.bind(this);
	this.productTab=this.productTab.bind(this);
	this.aboutUsTab = this.aboutUsTab.bind(this);
	this.postLoginTchr = this.postLoginTchr.bind(this);
	this.postLoginTchrTab = this.postLoginTchrTab.bind(this);
	this.showlog_Form_route=this.showlog_Form_route.bind(this);
	this.setPreloginClass = this.setPreloginClass.bind(this);
	this.postLoginCallBack = this.postLoginCallBack.bind(this);
	this.sgProductTab = this.sgProductTab.bind(this);

	this.SGCatalogue= this.SGCatalogue.bind(this);
	this.newINCatalogue = this.newINCatalogue.bind(this);

	this.switchProdType = this.switchProdType.bind(this);

	this.getHeaderLogo = this.getHeaderLogo.bind(this);
}

postLoginCallBack(){
	this.setState({PLPloggedIn:true,loggedIn:true});
}

getSchoolId(){
	return this.getUser().getSchoolId();
}

handleStateChange (state) {
	this.setState({menuOpen: state.isOpen})  
}

closeMenu () {
	this.setState({menuOpen: false})
}
getBannerContent(){
	  //console.log(maintenanceMessage);
	  if(maintenanceMessage.showBanner){
	  	return(
	  		<div className="maintenance-banner-container">
	  		<div className="maintenance-banner flex-row justify-center">
	  		<div className="banner-icon flex-col justify-center"><i className="fa fa-exclamation-circle" aria-hidden="true"></i></div>
	  		<div className="maintenance-banner-content flex flex-col justify-center">
	  		<h3 className="title">{maintenanceMessage.bannerMessage.title}</h3>
	  		<p className="message">{maintenanceMessage.bannerMessage.content}</p>
	  		<div className="banner-close" onClick={this.closeBanner}><i className="fa fa-times" aria-hidden="true"></i></div>
	  		</div>
	  		</div>
	  		</div>
	  		);	
	  	}
	  }

	  closeBanner(){
	  	var bannerContainer = document.getElementsByClassName("maintenance-banner-container");
	  	bannerContainer[0].style.display = "none";
	  }

	  menuSelected(event){
	  	var target = event.currentTarget;
	  	$(".heyMenu").removeClass("selected");
	  	var selectedclass = $(target).attr("data-classname");
	  	//console.log(selectedclass, target);
	  	$("."+selectedclass).addClass("selected");
	  	this.closeMenu();
	  	this.setState({preloginClassName:"PreLogin"});
	  }
	  showSettings (event) {
	  	event.preventDefault();
	  }  
	  componentWillMount(){		 
	  	this.PLPSessionCheck();
	  	this.LumosSessionCheck();
	  	console.log(this.props.location.pathname);
	  	if(this.props.location.pathname == "/landing" || this.props.location.pathname == "/dashboard" || this.props.location.pathname == "/settings" || this.props.location.pathname == "/report" || (this.props.location.pathname).indexOf("/scorecard") > -1){
	  		this.setState({preloginClassName:"PreLoginLanding"});
	  	}else{
	  		this.setState({preloginClassName:"PreLogin"});
	  	}
	  }
	  setPreloginClass(){
	  	//To force select home icon on menu img
	  	this.menuSelected();
	  	this.setState({preloginClassName:"PreLogin"});
	  }
	  userNameUpdateEvent(username){	
	  	this.setState({userName:username});
	  }
	  UpdateProfileImage(imageUrl){
	  //console.log("updateimage in home::"+imageUrl);
	  if(imageUrl){
	  	this.setState({imagePreviewUrl:imageUrl, imageLoaded:true});
	  }else{
	  	this.setState({imageLoaded:false});
	  }
	}
	loadCurrentImage(){
	  //alert("loadCurrentImage....");
	  var me = this;
	  var success = function(response){
	  	if(response && response.imgUrl){
	  		me.setState({imagePreviewUrl:response.imgUrl, imageLoaded:true});
	  	}
	  } 

	  var failure = function(err){

	  }

	  new HmAjax(this.getUrlFor("PROFILE_PIC")).get(success, failure);
	}
	PLPSessionCheck(){	
		
		var me = this;
		var user_Success = function(userObj){	
			console.log("session check succes....");
			if(typeof userObj === "object" && userObj.authToken){
				me.getUser().store(userObj);

				me.setState({PLPloggedIn:true,loginRequestComplete:true,userRole:userObj.userRole.role,userName:userObj.userName});
				if(me.headerComponent){
					me.setLoginState(true);
				}
				me.loadCurrentImage();
				me.showlog_Form_route();
				/*if(userObj.userRole.role == "STU"){
					me.props.history.push('/landing');
				}*/				
				
			}else{
				me.setState({PLPloggedIn:false,loginRequestComplete:true});
				me.setLoginState(false);	
				me.showlog_Form_route();			
			}
			
			me.detectGmailGExists();
		}

		var user_Failure = function(error){
			me.setState({PLPloggedIn:false,loginRequestComplete:true});
			me.showlog_Form_route();
			me.setLoginState(false);
			try{
				BrowserStorageUtil.removeItem(me.state.purchaseKey);
			}catch(e){
				if(console)
					console.error(e);
			}	
			
			me.detectGmailGExists();
		}		
		
		me.sessionCheck(user_Success,user_Failure);
	} 	
	LumosSessionCheck(){	
		
		var me = this;
		var user_Success = function(userObj){	
			if(typeof userObj === "object" && userObj.sessionValid){
				me.setState({LumosloggedIn:true,loginRequestComplete:true});
				me.showlog_Form_route();			
				console.log("LumosloggedIn ",me.state.LumosloggedIn);
				let lumosRedirect = true;

				if(window.lumos_allowed_routes && window.lumos_allowed_routes.length > 0){
					for(var i=0;i<window.lumos_allowed_routes.length;i++){
						if(window.location.href && window.location.href.match(window.lumos_allowed_routes[i])){
							lumosRedirect = false;
							break;
						}
					}
				}

				/*if(window.lumos_restricted_routes && window.lumos_restricted_routes.length > 0){
					for(var i=0;i<window.lumos_restricted_routes.length;i++){
						if(window.location.href && window.location.href.match(window.lumos_restricted_routes[i])){
							lumosRedirect = true;
							break;
						}
					}
				}*/

				if(lumosRedirect){
					//For a Lumos User, always redirect him to Lumos Page
					window.location.href = me.getUrlFor("LUMOS_REDIRECT_URL");		
				}
			}else{
				me.setState({LumosloggedIn:false,loginRequestComplete:true});
				me.showlog_Form_route();
			}
		}

		var user_Failure = function(error){
			me.setState({LumosloggedIn:false,loginRequestComplete:true});
			me.showlog_Form_route();
		}		
		new NativeAjax(this.getUrlFor("LUMOS_SESSION_CHECK")).enableCORS().get(user_Success,user_Failure);		
	} 
	setLoginState(isLoggedIn){
		this.setState({loggedIn:isLoggedIn});
	}
	hideHelpLoginModal(){
		this.setState({"HelpModalShow":false});
	}
	hideLoginModal(){
		this.setState({"ModalShow":false,customClass:""});
	}
	showForgotHelpScreen(){		
		this.setState({"HelpModalShow":true,"HelpModalContent":this.getPwdHelpContent(),customClass:"resetpasword"});
	}
	showSignupForm(loginType,userInput,gaFrom){
		this.gaFrom = gaFrom;
		this.setState({"ModalShow":true,"ModalContent":this.getVerifyAccount(loginType,userInput),"ModalHeader":this.rb("login.createnewaccount"),customClass:"newloginDialog"});
	}
	showNewLoginForm(loginType,userInput,gaFrom){
		this.gaFrom = gaFrom;
		//this.setState({"ModalShow":true,"ModalContent":this.getPLPLoginForm(loginType,userInput),"ModalHeader":"logo", customClass:"newloginDialog"});
		this.setState({"ModalShow":true,"ModalContent":this.getUnifiedLoginForm(loginType,userInput),"ModalHeader":"logo", customClass:"newloginDialog"});
	}
	
	showCreateAccount(navigateurl=null,freetrail=null,gaFrom=""){
		this.gaFrom = gaFrom;
		this.modalcloseDataGA = "Home - Users who have independently registered - Sign Up - New User - Start Learning - Close";
		this.setState({"ModalShow":true,"ModalContent":this.getVerifyAccount(null,null,navigateurl,freetrail),"ModalHeader":this.rb("login.createnewaccount"),customClass:"newloginDialog teacherJoinForm"});
	}
	showForgotPasswordForm(source){
		let mycustomclass="";
		this.modalcloseDataGA = "Home - Sign in - Users enrolled through school - Forgot Password";
		if(source == "plp"){
			this.modalcloseDataGA = "Home - Sign in - Users who have independently registered - Forgot Password";
			mycustomclass = "resetpasword newloginDialog";
		}else{
			mycustomclass = "resetpasword newloginDialog";
		}
		this.setState({"ModalShow":true,"ModalContent":this.getForgotPassword(source),"ModalHeader":this.rb("rpwd.title"),customClass:mycustomclass});
	}
	getPwdHelpContent(){
		return ( 
			<div id="loginRoot">
			<div className="container">
			<div className="col-12 josefin">
			<div className="loginHeaderTxt">For Parent Account:</div> 
			<div>Please use the email address you used to register with HeyMath!</div>
			<br />
			<div className="loginHeaderTxt">For Student Account:</div> 							
			<div className="mt-10">If you have not updated your email address in your Settings, please use the parent email address that was used to register with HeyMath!</div>
			<div className="mt-10">If you have updated your email address in your account settings (as shown below), please use that email ID to reset your password.</div>
			<br />
			<div>
			<img src={pwdhelpscrn}/>
			</div>
			<br />							
			</div>	
			</div>	
			</div>	
			);
		}
		
		showSubscriptionForm(callBack){
			let me = this;
			let success = function(resp){
				me.setState({"ModalShow":false});
				if(typeof callBack === "function"){
					callBack();
				}
								
			}

			this.setState({"ModalShow":true,"ModalContent":this.getUnifiedLoginFormWithoutNav(null,null,null,null,success),"ModalHeader":"logo", customClass:"newloginDialog"});
		}


		showSubscriptionForm_deprecated(productObj){
			var purchaseObj = {
				tariffId:productObj.tariffId,
				productId:productObj.productId
			}
			BrowserStorageUtil.storeItem(this.state.purchaseKey, JSON.stringify(purchaseObj));

			var gradeid = "";
			var category = "";
			var freetrail = "";
			try{
				gradeid = productObj.gradeid;
				category = productObj.productCategory;
				freetrail = false; //productObj.freetrail;

				var tarrrifid = productObj.tariffId;
				var productid = productObj.productId;
				var buyagain = productObj.buyagain;
				

				var trackObj = {
					"grade_id": gradeid.length > 0 ? parseInt(gradeid) : null,
					"product_type": category,
					"tariff_id":tarrrifid
				}

				this.storeTrackEvent("purchase_viewed", trackObj);

			}catch(e){}
			
			try{
				if(!gradeid && localStorage.getItem("product") && localStorage.getItem("product").length > 0){
					let _prodId = localStorage.getItem("product");
					if(_prodId){
						let _tempProdDetails = JSON.parse(localStorage.getItem("proDetail"));
						
						gradeid = _tempProdDetails[_prodId].productOrigin || "";
						
						if(gradeid && gradeid.length > 0){
							localStorage.setItem("grade",gradeid);
						}
					}
				}else{
					gradeid = "";
				}
			}catch(e){
				gradeid = "";
			}
			
			if(this.state.PLPloggedIn == true){
				if(freetrail === "true"){
					//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"free-"+category+"-class-"+gradeid+"-btn-click"});
					this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-logged-freetrial-btn"});
				}else{
					//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"paid-"+category+"-class-"+gradeid+"-subscribe-btn-click"});
					this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-logged-subscribe-btn"});
				}

				this.setState({selectedTarriffID:productObj.tarrifid});
				// if(buyagain && buyagain == "true"){
				// 	window.location.href = '/product-details/';
				// }else{
				// 	this.props.history.push('/product-details/');
				// }
			}else{
				if(freetrail === "true"){
					//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"free-"+category+"-class-"+gradeid+"-loginform"});
					this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-loginform-freetrial-btn"});
				}else{
					//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"paid-"+category+"-class-"+gradeid+"-subscribe-loginform"});
					this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-loginform-subscribe-btn"});
				}

				this.modalcloseDataGA = "Home - Sign in - Subscription - close";
				this.setState({"ModalShow":true,"ModalContent":this.getSubScripeLoginForm(freetrail),"ModalHeader":"logo",selectedTarriffID:productObj.tarrifid,customClass:"newloginDialog"});
			}			
			
		}






		showSubScripeLoginForm(event){
			var purchaseObj = {
				tarrrifid:event.currentTarget.dataset.tarrifid,
				productid:event.currentTarget.dataset.productid
			}
			BrowserStorageUtil.storeItem(this.state.purchaseKey, JSON.stringify(purchaseObj));

			var gradeid = "";
			var category = "";
			var freetrail = "";
			try{
				gradeid = event.currentTarget.dataset.gradeid;
				category = event.currentTarget.dataset.category;
				freetrail = event.currentTarget.dataset.freetrail;

				var tarrrifid = event.currentTarget.dataset.tarrifid;
				var productid = event.currentTarget.dataset.productid;
				var buyagain = event.currentTarget.dataset.buyagain;
				

				var trackObj = {
					"grade_id": gradeid.length > 0 ? parseInt(gradeid) : null,
					"product_type": category,
					"tariff_id":tarrrifid
				}

				this.storeTrackEvent("purchase_viewed", trackObj);

			}catch(e){}
			
			try{
				if(!gradeid && localStorage.getItem("product") && localStorage.getItem("product").length > 0){
					let _prodId = localStorage.getItem("product");
					if(_prodId){
						let _tempProdDetails = JSON.parse(localStorage.getItem("proDetail"));
						
						gradeid = _tempProdDetails[_prodId].productOrigin || "";
						
						if(gradeid && gradeid.length > 0){
							localStorage.setItem("grade",gradeid);
						}
					}
				}else{
					gradeid = "";
				}
			}catch(e){
				gradeid = "";
			}
			
			if(this.state.PLPloggedIn == true){
				if(freetrail === "true"){
					//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"free-"+category+"-class-"+gradeid+"-btn-click"});
					this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-logged-freetrial-btn"});
				}else{
					//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"paid-"+category+"-class-"+gradeid+"-subscribe-btn-click"});
					this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-logged-subscribe-btn"});
				}

				this.setState({selectedTarriffID:event.currentTarget.dataset.tarrifid});
				if(buyagain && buyagain == "true"){
					window.location.href = '/product-details/';
				}else{
					this.props.history.push('/product-details/');
				}
			}else{
				if(freetrail === "true"){
					//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"free-"+category+"-class-"+gradeid+"-loginform"});
					this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-loginform-freetrial-btn"});
				}else{
					//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"paid-"+category+"-class-"+gradeid+"-subscribe-loginform"});
					this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-loginform-subscribe-btn"});
				}

				this.modalcloseDataGA = "Home - Sign in - Subscription - close";
				this.setState({"ModalShow":true,"ModalContent":this.getSubScripeLoginForm(freetrail),"ModalHeader":"logo",selectedTarriffID:event.currentTarget.dataset.tarrifid,customClass:"newloginDialog"});
			}
			
			
		}

		showLoginForm(e){
		//alert("showLoginForm"+this.state.LumosloggedIn+" : "+this.state.PLPloggedIn);
		if(this.state.LumosloggedIn == true || (BrowserUtil.getLumosToken() && BrowserUtil.getLumosToken().length >= 5)){
			window.top.location.href = this.getUrlFor("LUMOS_REDIRECT_URL");
		}else if(this.state.PLPloggedIn == true || (BrowserUtil.getAuthToken() && BrowserUtil.getAuthToken().length >= 5)){
				/*if(this.state.userRole == "PRNT"){
						window.top.location.href = '/myproducts';
			   }else{
						window.top.location.href = '/landing';
					}*/
					if(this.allProductsExpired()){
						window.top.location.href = '/landing';                          
					}else if(!this.productsAvailableToAccess()){
						window.top.location.href = '/landing';
					}else{
						window.top.location.href = '/landing';  
					}
				} 
				else{
			//alert("showlogin else");
			   //this.modalcloseDataGA = "Home - Sign in - close";
			   //this.setState({"ModalShow":true,"ModalContent":this.getLoginForm(),"ModalHeader":this.rb("signin.heading"),customClass:""});
			   this.getSingleLoginForm(e)
			}
		}

		allProductsExpired(){
			var productsInHistory = false;

			var user = this.getUser();
			if(user != null){
				var productsAvailable = this.productsAvailableToAccess();

				var entlHistory = user.getEntlHistory();
				if(entlHistory != null && Object.keys(entlHistory).length > 0){
					for(var i in entlHistory){
						if(entlHistory[i] != null){
							var totalLevel = entlHistory[i].split(",").reduce(function(a,b){
								try{
									return parseInt(a) + parseInt(b);
								}catch(e){
									return 0;
								}
							});

							if(totalLevel > 0){
								productsInHistory = true;
								break;
							}
						}
					}
				}

			}

			return (productsInHistory && !productsAvailable);
		}

		productsAvailableToAccess(){
			var user = this.getUser();
			if(user != null){
				var permissions = user.getPermissions();
				if(permissions != null && Object.keys(permissions).length > 0){
					for(var i in permissions){
						if(permissions[i] != null){
							var totalLevel = permissions[i].split(",").reduce(function(a,b){
								try{
									return parseInt(a) + parseInt(b);
								}catch(e){
									return 0;
								}
							});

							if(totalLevel > 0){
								return true;
							}
						}
					}
				}
			}

			return false;
		}
		showSignUp(loginType,userInput,gaFrom){
			console.log("loginType::",loginType," userInput::",userInput);
			this.gaFrom = gaFrom;
			this.showSignupForm(loginType,userInput,gaFrom);
		}
		startFreeTrial(){
			if(this.state.PLPloggedIn == true){
				
			if(this.getUserRole()=="TCHR"){
				window.top.location.href = '/teachers';
			}else{
				window.top.location.href = '/products';
			}
		}
		else{
			this.modalcloseDataGA = "Home - Sign in - Free Trail - close";
			this.setState({"ModalShow":true,"ModalContent":this.getFreeTrialPLPLoginForm(),"ModalHeader":"logo", customClass:""});
		}
	}

	getUserRole(){
		var role='';
		if(this.UserStore){
		if(this.getUser() && this.getUser().get()){
			role = this.getUser().get().userRole.role;
			} 
	 }
		return role;
	}

	showLiveFeedLogin(){
		this.setState({"ModalShow":true,"ModalContent":this.getLiveFeedLoginForm(),"ModalHeader":"logo", customClass:"newloginDialog"});
	}
	showContactusForTeacher(){
		this.modalcloseDataGA = "Footer - Contact Us - Close";
		this.setState({"ModalShow":true,"ModalContent":this.getTchrContactusForm(),"ModalHeader":this.rb("contactus.title"), customClass:"contactus"});
	}
	showContactus(){
		this.modalcloseDataGA = "Footer - Contact Us - Close";
		this.setState({"ModalShow":true,"ModalContent":this.getContactusForm(),"ModalHeader":this.rb("contactus.title"), customClass:"contactus"});
	}
	showSuccessContactMessage(msg){
		this.setState({"ModalShow":true,"ModalContent":this.getSuccessPwdMsg(msg),"ModalHeader":this.rb("contactus.title"), customClass:"contactus"});
	}
	showSuccessForgotPwdMessage(msg){
		this.setState({"ModalShow":true,"ModalContent":this.getSuccessPwdMsg(msg),"ModalHeader":this.rb("rpwd.title")});
	}
	showsuccessRegisterMsg(msg){
		this.setState({"ModalShow":true,"ModalContent":this.getSuccessPwdMsg(msg),"ModalHeader":this.rb("login.createnewaccount")});
	}
	getSuccessPwdMsg(msg){
		return(
			<div className="successPwdMsg text-center">{ReactHtmlParser(msg)}</div>
			);
		}
		renderModalHeader(){
			if(this.state.ModalHeader != "logo"){
				if(this.state.customClass == "resetpasword"){
					return (<div><div className="text-center loginHeaderTxt josefinsansFont">{this.state.ModalHeader} <i className="material-icons" onClick={this.showForgotHelpScreen}>info</i></div></div>);
				}else{
					return (<div><div className="text-center loginHeaderTxt josefinsansFont">{this.state.ModalHeader}</div></div>);
				}
			}else{
				//return (<img src={heymathlogo} className="heymathlogo" width="120"/>);
			}
		}
		getCreateAccount(){
			return(
				<CreateNewAccountForm myProps={this.props} successRegisterMsg={this.showsuccessRegisterMsg} navigateURL="/product-details" />
				);
		}
		getVerifyAccount(loginType=null,userInput=null,navigateurl=null,freetrail=null){
			if(navigateurl == null){
				navigateurl = '/products';
			}
			console.log("calling signup this.gaFrom:::",this.gaFrom);
			return(				
				<SignupForm signupUser={'student'} myProps={this.props} loginType={loginType} data-ga={this.modalcloseDataGA} userInput={userInput} successRegisterMsg={this.showsuccessRegisterMsg} navigateURL={navigateurl} freetrail={freetrail} gaFrom={this.gaFrom} />
				);
		}
		getContactusForm(){
			return ( 
				<div>					
				<div className="row">									
				<div className="col-12 nopadding">
				<Contactus myProps={this.props} successContactus={this.showSuccessContactMessage}/>
				</div>

				</div>
				</div>
				);
			}

			getTchrContactusForm(){
				return ( 
				<div>					
				<div className="row">									
				<div className="col-12 nopadding">
				<TchrContactus myProps={this.props} successContactus={this.showSuccessContactMessage}/>
				</div>

				</div>
				</div>
				);
			}

			getSubScripeLoginForm(freetrail){
				return ( 
				<div>					
				<div className="row">									
				<div className="col-12 nopadding">
				<UnifiedLogin myProps={this.props} callbackForgotPwd={this.showForgotPasswordForm} callbackCreateAccount={this.showCreateAccount} showSignUp={this.showSignUp} navigateURL="/product-details"  freetrail={freetrail}/>
			{/* <LoginForm myProps={this.props} callbackForgotPwd={this.showForgotPasswordForm} callbackCreateAccount={this.showCreateAccount} showSignUp={this.showSignUp} navigateURL="/product-details"  freetrail={freetrail}/> */}
			</div>

			</div>
			</div>
			);
		}
		getSingleLoginForm(event){

			let loginSource = event.currentTarget.dataset.source || '';

			if(loginSource == "" || loginSource == "lumos" || loginSource == "plp"){
				this.modalcloseDataGA = "Home - Users who have independently registered - Close";
				this.setState({"ModalShow":true,"ModalContent":this.getUnifiedLoginForm(),"ModalHeader":"logo", customClass:"newloginDialog"});
			}else if(loginSource == "register"){
				this.modalcloseDataGA = "Home - Sign in - Users who want to register - Close";
				this.setState({"ModalShow":true,"ModalContent":this.getVerifyAccount(),"ModalHeader":this.rb("login.createnewaccount"),customClass:"newloginDialog"});
			}


			//console.log("loginFrom="+loginSource);
			// if(loginSource == "lumos"){
			// 	this.modalcloseDataGA = "Home - Sign in - Users enrolled through school - Close";
			// 	this.setState({"ModalShow":true,"ModalContent":this.getLumosLoginForm(),"ModalHeader":"logo", customClass:"loginlumos"});
			// }else if(loginSource == "plp"){
			// 	this.modalcloseDataGA = "Home - Users who have independently registered - Close";
			// 	this.setState({"ModalShow":true,"ModalContent":this.getPLPLoginForm(),"ModalHeader":"logo", customClass:"newloginDialog"});
			// }else if(loginSource == "register"){
			// 	this.modalcloseDataGA = "Home - Sign in - Users who want to register - Close";
			// 	this.setState({"ModalShow":true,"ModalContent":this.getVerifyAccount(),"ModalHeader":this.rb("login.createnewaccount"),customClass:"newloginDialog"});
			// }
		}

		loginFormOnLoad(source){
			if(this.state.loggedIn || this.state.LumosloggedIn || (BrowserUtil.getAuthToken() && BrowserUtil.getAuthToken().length >= 5) || (BrowserUtil.getLumosToken() && BrowserUtil.getLumosToken().length >= 5)){
				return;
			}
			if(source == "plp" || source == "lumos"){
				this.modalcloseDataGA = "Home - Sign in - Users enrolled through school - Close";
				this.setState({"ModalShow":true,"ModalContent":this.getUnifiedLoginForm(),"ModalHeader":"logo", customClass:"loginlumos"});
			}else if(source == "register"){
				this.modalcloseDataGA = "Home - Sign in - Users who want to register - Close";
				this.setState({"ModalShow":true,"ModalContent":this.getVerifyAccount(),"ModalHeader":this.rb("login.createnewaccount"),customClass:"newloginDialog"});
			}


			// else if(source == "lumos"){
			// 	this.modalcloseDataGA = "Home - Sign in - Users enrolled through school - Close";
			// 	this.setState({"ModalShow":true,"ModalContent":this.getLumosLoginForm(),"ModalHeader":"logo", customClass:"loginlumos"});
			// }else if(source == "plp"){
			// 	this.modalcloseDataGA = "Home - Users who have independently registered - Close";
			// 	this.setState({"ModalShow":true,"ModalContent":this.getPLPLoginForm(),"ModalHeader":"logo", customClass:"newloginDialog"});
			// }
		}

		getLoginForm(){

			return ( 			
				<div className="signinContainer josefinsansFont">
			{/*<div className="text-center signinheading">{this.rb("signin.heading")}</div>*/}
			<br/>
			<div className="row">
			<div className="col-12 clearfix text-center mt-15">
			<div data-ga="Home - Sign in - Users enrolled through school" className="card school" data-source="lumos" onClick={this.getSingleLoginForm}>								
			<div className="card-top">
			<div className="text-center">
			<div className="top-icon"><img src={schoolSigninIcon} /></div>
			<div className="top-heading">{ReactHtmlParser(this.rb("signin.school.cardheading"))}</div>
			</div>
			</div>
			<div className="card-body">
			<div className="card-text">{this.rb("signin.school.content")}</div>
			<div className="text-right arrow"><i className="material-icons">chevron_right</i></div>
			</div>
			</div>	

			<div data-ga="Home - Sign in - Users who have independently registered" className="card individual" data-source="plp" onClick={this.getSingleLoginForm}>								
			<div className="card-top">
			<div className="text-center">
			<div className="top-icon"><img src={plpSigninIcon} /></div>
			<div className="top-heading">{ReactHtmlParser(this.rb("signin.individual.cardheading"))}</div>
			</div>
			</div>
			<div className="card-body">
			<div className="card-text">{this.rb("signin.individual.content")}</div>
			<div className="text-right arrow"><i className="material-icons">chevron_right</i></div>
			</div>
			</div>
			</div>	

			</div>	
			<br/>
			</div>	
			);
		}
		getLumosLoginForm(){
			return ( 
			<div>					
			<div className="row">
			<div className="col-12 nopadding">
			<LumosLoginForm myProps={this.props} loginIframeView={this.loginIframeView} callbackForgotPwd={this.showForgotPasswordForm}/>
			</div>	


			</div>
			</div>
			);
		}

		getUnifiedLoginForm(loginType=null,userid=null,errMsg=null){
			return ( 
			<div>                   
			<div className="row">                                   
			<div className="col-12 nopadding">
			<UnifiedLogin myProps={this.props} loginType={loginType} userid={userid} callbackForgotPwd={this.showForgotPasswordForm} callbackCreateAccount={this.showCreateAccount} showSignUp={this.showSignUp} navigateURL={'/products'} errMsg={errMsg}/>
			</div>
			<br/>
			</div>
			</div>
			);
		}

		getUnifiedLoginFormWithoutNav(loginType=null,userid=null,errMsg=null, navUrl = null, callBack=null){
			return ( 
			<div>                   
			<div className="row">                                   
			<div className="col-12 nopadding">
			<UnifiedLogin myProps={this.props} loginType={loginType} userid={userid} callBack={callBack} callbackForgotPwd={this.showForgotPasswordForm} callbackCreateAccount={this.showCreateAccount} showSignUp={this.showSignUp} navigateURL={navUrl} errMsg={errMsg}/>
			</div>
			<br/>
			</div>
			</div>
			);
		}

		getPLPLoginForm(loginType=null,userid=null,errMsg=null){
			return ( 
			<div>					
			<div className="row">									
			<div className="col-12 nopadding">
			<LoginForm myProps={this.props} loginType={loginType} userid={userid} callbackForgotPwd={this.showForgotPasswordForm} callbackCreateAccount={this.showCreateAccount} showSignUp={this.showSignUp} navigateURL={'/products'} errMsg={errMsg}/>
			</div>
			<br/>
			</div>
			</div>
			);
		}
		getFreeTrialPLPLoginForm(){
			return ( 
			<div>					
			<div className="row">									
			<div className="col-12 nopadding">
		{/* <LoginForm myProps={this.props} callbackForgotPwd={this.showForgotPasswordForm} callbackCreateAccount={this.showCreateAccount} showSignUp={this.showSignUp} navigateURL="/products"/> */}
		<UnifiedLogin myProps={this.props} callbackForgotPwd={this.showForgotPasswordForm} callbackCreateAccount={this.showCreateAccount} showSignUp={this.showSignUp} navigateURL={'/products'}/>
		</div>
		<br/>
		</div>
		</div>
		);
	}

	getLiveFeedLoginForm(){
		return ( 
		<div>					
		<div className="row">									
		<div className="col-12 nopadding">
		<LoginForm myProps={this.props} callbackForgotPwd={this.showForgotPasswordForm} callbackCreateAccount={this.showCreateAccount} showSignUp={this.showSignUp} navigateURL="/" liveFeed="true" />
		</div>
		<br/>
		</div>
		</div>
		);
	}



	getForgotPassword(source){
		return ( 
		<div>                   
		<div className="row">
		<div className="col-12 nopadding">
		<UnifiedForgotPwd myProps={this.props} pwdIframeView={this.pwdIframeView} source={source} successForgotPwd={this.showSuccessForgotPwdMessage} showNewLoginForm={this.showNewLoginForm}/>
		</div>      
		</div>
		</div>
		);

		/*if(source == "plp"){			
			return ( 
				<div>					
				<div className="row">
				<div className="col-12 nopadding">
				<ForgotPwd myProps={this.props} pwdIframeView={this.pwdIframeView} source={source} successForgotPwd={this.showSuccessForgotPwdMessage} showNewLoginForm={this.showNewLoginForm}/>
				</div>		
				</div>
				</div>
				);
			}else{
				return ( 
				<div>					
				<div className="row">
				<div className="col-12 nopadding">
				<ForgotPasswordForm myProps={this.props} pwdIframeView={this.pwdIframeView} source={source} successForgotPwd={this.showSuccessForgotPwdMessage}/>
				</div>		
				</div>
				</div>
				);
			}*/
		}

		getButtonName(){
			//console.log("lumos login::::",this.state.LumosloggedIn);
			if(this.state.loggedIn || this.state.LumosloggedIn || (BrowserUtil.getAuthToken() && BrowserUtil.getAuthToken().length >= 5) || (BrowserUtil.getLumosToken() && BrowserUtil.getLumosToken().length >= 5)){
				return this.rb("btn.label.myheymath");
			}
			return this.rb("btn.label.signin");
		}

		getMargin(){
			if(this.state.loggedIn == false){
				if(this.state.LumosloggedIn){
					return "";
				}
				return "mt-7";
			}else{			
				return "";
			}
		}
		getErrorPage(){
			window.top.location.href="/404";
		}
		onLogout(){
			var me = this;

			var msg = me.rb("logout.msg");
			var buttons = [{
				label: me.rb("alert.ok"),
				handler: () => { me.doLogout() }
			},
			{
				label: me.rb("alert.cancel"),
				handler: () => { }
			}]

			me.showAlert(" ", msg, buttons);
		}
		doLumosLogout(){
			var me = this;
		//console.log("logout url="+me.getUrlFor("LUMOS_LOGOUT"));
		$.ajax({
			url: me.getUrlFor("LUMOS_LOGOUT"),	            
			type: 'GET',
			xhrFields: {
				withCredentials: true
			},
			crossDomain: true,
			success: function(response){	            	
				me.setState({LumosloggedIn:false});	
			},
			error: function(response){
				console.log("Error in LUMOS_LOGOUT",response);
				me.setState({LumosloggedIn:false});	
			}
		});
	}

	doCommonLogout(){
		
		let redirectUrl = null;
		/*if(BrowserUtil.getCookie("loginSrc") && BrowserUtil.getCookie("loginSrc").length > 10){
			redirectUrl = (BrowserUtil.getCookie("loginSrc")).replace(/"/g,"");
		}else{
			redirectUrl = (this.getUrlFor("PRELOGIN_PAGE")).replace(/"/g,"");
		}*/
		if(this.getUrlFor("PRELOGIN_PAGE") && this.getUrlFor("PRELOGIN_PAGE").length > 0){
			redirectUrl = (this.getUrlFor("PRELOGIN_PAGE")).replace(/"/g,"");
		}else if(this.getUrlFor("HEYMATH_HOME") && this.getUrlFor("HEYMATH_HOME").length > 0){
			redirectUrl = (this.getUrlFor("HEYMATH_HOME")).replace(/"/g,"");
		}

		var me = this;
		var callBackSuccess = function(){

			me.initiateTrack("logout",{});

			setTimeout(function(){
				me.UserStore.clearOldUser();
				window.location.href = redirectUrl; //me.getUrlFor("PRELOGIN_PAGE");
			},500);

		}

		var PLPcallBackFailure = function(){
			window.location.href = redirectUrl; //me.getUrlFor("PRELOGIN_PAGE");
			console.error("Logout failed.");
		}

		var callBackFailure = function(response,request){
			//window.location.href = me.getUrlFor("PRELOGIN_PAGE");
			if(request.status!=403){
				console.error("Logout failed.");
				new NativeAjax(me.getUrlFor("PLP_COMMON_LOGOUT")).enableCORS().get(callBackSuccess, PLPcallBackFailure);
			}else{
				window.location.href = redirectUrl; // me.getUrlFor("PRELOGIN_PAGE");
			}
		}

		new NativeAjax(this.getUrlFor("LUMOS_COMMON_LOGOUT")).enableCORS().get(callBackSuccess, callBackFailure);
	}

	doPLPLogout(){
		var me = this;
		var callBackSuccess = function(){

			me.initiateTrack("logout",{});

			setTimeout(function(){
				me.UserStore.clearOldUser();
				window.location.href = me.getUrlFor("PRELOGIN_PAGE");
			},500);

		}

		var callBackFailure = function(){
			console.error("Logout failed.");
		}
		new HmAjax(me.getUrlFor("LOGOUT")).get(callBackSuccess,callBackFailure);
	}

	
	doLogout(){
		var me = this;

		//console.log("logout ",me.UserStore.getAuthProviderId())
		// if(me.UserStore.getAuthProviderId() === 5){
		// 	me.doLumosLogout();
		// }
		
		try{
			BrowserStorageUtil.removeSessionItem(me.state.navigationKey);
		}catch(e){
			if(console)
				console.error(e);
		}		
		//me.doPLPLogout();
		me.doCommonLogout();
	}


	renderLoginView(){
		if(this.state.loggedIn == true){
 // return(<a className="pl-20 logoutIcon" href="#" onClick={() => {this.onLogout()}}><i className="material-icons">power_settings_new</i></a>);
 let lumosHidden = "";
 if(this.state.LumosloggedIn){
 	lumosHidden = "hidden";
 }

 return(
 	<div className="inlineblock">
 {/*<div className="inlineblock pr-10 usernamedisp d-md-none d-sm-none d-lg-inlineblock" title={this.state.userName}>{this.state.userName}</div>*/}

 <div className="inlineblock navbar-nav">
 <li className="nav-item dropdown">
 <div className="nav-link dropdown-toggle" href="#" id="navbardrop" data-toggle="dropdown">
{/*<i className="material-icons md-40 useraccountelement">account_circle</i>*/}
{ this.state.imageLoaded ? <img className="material-icons md-60  usericon imgprv" src={ this.state.imagePreviewUrl} /> : <i className="material-icons md-40 useraccountelement">account_circle</i> }
</div>
<div className="dropdown-menu">
{(() => {
	if(this.isHeaderMenuAllowed("my_products")){
		return (<a className={"dropdown-item " + lumosHidden} href="/myproducts" data-ga="Home - My Subscriptions"><i className="material-icons pr-16">credit_card</i> My Subscriptions</a>);
	}
})()}

<a className={"dropdown-item " + lumosHidden} href="/settings" ><i className="material-icons pr-16">account_circle</i> My Profile</a>
{/* {this.chooseclass()} */}
<a className="dropdown-item" href="#" onClick={() => {this.onLogout()}}><i className="material-icons pr-16">power_settings_new</i> Sign out</a>
</div>
</li>
</div>
</div>
);
}
}  

renderClassView(){
	var me=this;
	return(
		<div id="productdd" className="inlineblock">
		<div className="inlineblock navbar-nav">
		<li className="nav-item dropdown">
		<div className="nav-link dropdown-toggle cont" href="#" id="navbardrop" data-toggle="dropdown">
		<span className="procont">{this.rb("in.products.students.title")}</span>
		</div>

		<ProductMenu products_category_order={me.getProductsTypeOrder()} products_category={me.getProductsType()} classes={me.getClasses()} grades={me.getGrades()} products_class={me.getProductsClass()}></ProductMenu>    

		</li>
		</div>
		</div>
		);
} 

renderAboutUsMenu(){
	var me=this;
	return(
		<div id="aboutContent" className="inlineblock">
		<div className="inlineblock navbar-nav">
		<li className="nav-item dropdown">
		<div className="nav-link dropdown-toggle cont" href="#" id="navbardrop" data-toggle="dropdown">
		<span className="aboutcont">{this.rb("header.label.about.tab")}</span>
		</div>
		<div id="about-menu" className="dropdown-menu">
        <div className="dropdown-item">
		<div className="splwell">
			<div className="row">
			<div className="about-menu">
			<span data-ga="Who we are - Main Tab" ><Link className="heyMenu menuwhoweare" data-classname="menuwhoweare" to="/who-we-are" onClick={this.menuSelected}>Who We Are</Link>
			</span></div>
			<div className="about-menu">
			<span data-ga="Our Learning - Main Tab"><Link className="heyMenu menuourlearnings" data-classname="menuourlearnings" to="/our-learnings" onClick={this.menuSelected}>Our Learnings</Link>			
			</span></div>
			<div className="about-menu">
			<span data-ga="Spotlight - Main Tab" ><Link className="heyMenu menuspotlight" data-classname="menuspotlight" to="/spotlight" onClick={me.menuSelected}>Spotlight</Link>
			</span></div>				
			</div>
				<div className="row atagalign">
            </div>	
	</div>
	</div>
           
      </div>
			
		</li>
		</div>
		</div>
		);
}


componentDidMount() {	 
	//console.warn("PreloginHome IN");
	var me = this;
	me.showlog_Form_route();
	HmEventRegistry.fireEvent("INITIATE_GA");
	HmEventRegistry.fireEvent("INITIATE_GA_EVENT");

	var callBackSuccess = function(result){
		if(result !== null){
			try{
				me.setState({
				isLoaded: true,
				grades: result.products_classification.IN.Board.CBSE.grade_order,
				classes: result.products_classification.IN.Board.CBSE.grades,
				products_class: result.products_classification.IN.Board.CBSE.grades,
				products_category: result.products_classification.IN.Board.CBSE.products_category,
				products_category_order: result.products_classification.IN.Board.CBSE.products_category_order,
				products_classification: result,

			});
			}catch(e){
				console.error(e);
			}			
		}
			//console.log("response : ", response);
		}

		var callBackFailure = function(response){
			me.setState({
				isLoaded: true,
				error:"Error in PRODUCT_CLASSIFICATION"
			});
			console.log("Error in PRODUCT_CLASSIFICATION");		
		}

		new HmAjax(this.getUrlFor("PRODUCT_CLASSIFICATION")).post(callBackSuccess,callBackFailure);		
		
		
		try{
			if(this.selectedMenu != null){
				$("."+this.selectedMenu).addClass("selected");
			}

		}catch(e){}
		
		
		if(!BrowserStorageUtil.getStoredSessionItem(this.plpTrackKey)) {
			BrowserStorageUtil.storeSessionItem(this.plpTrackKey, "[]");
		}

		const pathName = window.location.pathname;
		let windowAlert = (window.infoMaintenance && window.infoMaintenance.showBanner && window.infoMaintenance.bannerMessage[pathName]) || false;
		let hideCountryList = (window.infoMaintenance && window.infoMaintenance.hidecountryList) ? window.infoMaintenance.hidecountryList : [];
		let alreadyShown = (localStorage.getItem("banner-"+pathName) === "true");
		let currentGeo =  this.getGeo();
		let hideBasedCountry = (hideCountryList.length>0 && (hideCountryList.indexOf(currentGeo) > -1)) ? true : false;
		//console.warn("alreadyShown ",alreadyShown, " : ",hideCountryList, " : ",hideBasedCountry," : ",hideCountryList.indexOf(currentGeo));
		if(alreadyShown || hideBasedCountry){
			return;
		}
		let title = (window.infoMaintenance.bannerMessage && window.infoMaintenance.bannerMessage[pathName] && window.infoMaintenance.bannerMessage[pathName].title) ? window.infoMaintenance.bannerMessage[pathName].title : '';
		let bannerContent = (window.infoMaintenance.bannerMessage && window.infoMaintenance.bannerMessage[pathName] && window.infoMaintenance.bannerMessage[pathName].content) ? window.infoMaintenance.bannerMessage[pathName].content : '';
		if((title || bannerContent) && windowAlert && !alreadyShown){			
			this.setState({InfoModalShow:true,InfoModalContent:this.showInfoBannerUI(bannerContent),InfoModalHeader:title,customClass:"newloginDialog"});
		}
	}
	
	getGeo(){
		let geo = super.getGeo();
		return geo || "SG";
	}


	showInfoBannerUI(bannerContent){
		let message = (bannerContent) ? bannerContent : ''

		return message;
	}

	hideInfoModal(){
		const pathName = window.location.pathname;
		localStorage.setItem("banner-"+pathName, "true");
		this.setState({InfoModalShow:false});
	}

	redirecttoSomewhere = () => {
		this.hideInfoModal();
		window.location.href = '/products';
	}

	showlog_Form_route(){
		var me = this;
		//console.log("loginRequestComplete ",me.state.loginRequestComplete," : ",me.state.PLPloggedIn," : ",me.state.LumosloggedIn);
		if(me.state.loginRequestComplete && !me.state.PLPloggedIn && !me.state.LumosloggedIn){
			var qryParam = me.QueryStringToJSON();
			if(qryParam["loginForm"] && qryParam["loginForm"].length > 0){
				setTimeout(() => {
					me.loginFormOnLoad(qryParam["loginForm"]);
				}, 1000);
			}
		}
		
	}

	detectGmailGExists(){
		try{
			var params = this.QueryStringToJSON();
			if(Object.keys(params).length > 0){				
				if(params.g_exists == "true" || params.g_exists == true){
					//console.log("g_exists::this.state.PLPloggedIn=="+this.state.PLPloggedIn);
					if(this.state.PLPloggedIn == false || this.state.PLPloggedIn == "false"){
						var googleErrmsg = this.rb("google.forbiden.msg");
						//this.setState({"ModalShow":true,"ModalContent":this.getPLPLoginForm(null,null,googleErrmsg),"ModalHeader":"logo", customClass:"newloginDialog"});
						this.setState({"ModalShow":true,"ModalContent":this.getUnifiedLoginForm(null,null,googleErrmsg),"ModalHeader":"logo", customClass:"newloginDialog"});
					}
				}				
			}

		}catch(e){}
	}
	QueryStringToJSON() {            
		try{
			var pairs = this.props.location.search.slice(1).split('&');

			var result = {};
			pairs.forEach(function(pair) {
				pair = pair.split('=');
				result[pair[0]] = decodeURIComponent(pair[1] || '');
			});

			return JSON.parse(JSON.stringify(result));
		}catch(e){}

		return {};
	}
	getGrades(){
		if(this.state.grades !== [] && this.state.grades !== undefined){
			return this.state.grades;
		}
	}

	getClasses(){
		if(this.state.classes !== [] && this.state.classes !== undefined){
			return this.state.classes;
		}
	}

	getProductsClass(){
		if(this.state.products_class !== {} && this.state.products_class !== undefined){
			return this.state.products_class;
		}
	}


	getProductsClassification(){
		if(this.state.products_classification !== {} && this.state.products_classification !== undefined){
			return this.state.products_classification;
		}
	}

	getProductsType(){
		if(this.state.products_category !== {} && this.state.products_category !== undefined){
			return this.state.products_category;
		}
	}

	getProductsTypeOrder(){
		if(this.state.products_category_order !== [] && this.state.products_category_order !== undefined){
			return this.state.products_category_order;
		}
	}

	freeTrialUser(isTriedFree, isPurchased){
		this.setState({productsInfoAvailable:true,userProdReqComplete:true,triedFree:(isTriedFree),purchased:(isPurchased)});
	}


	checkUserFreeTrial(prodInfo){
		var me = this;
		if(prodInfo && prodInfo.productId && prodInfo.tariffId){
			var successFn = function(resp){
				try{
					if(resp && resp.response){
						console.log(resp.response);
						me.freeTrialUser(resp.response.free_accessed, resp.response.paid_accessed);

						/*if(resp.response === "error"){
							me.freeTrialUser(true);
						}else{
							me.freeTrialUser(false);
						}*/
					}
				}catch(e){

				}
			}

			var failureFn = function(err){
				console.warn("Error while checking for the product free usage :", err);
  			//IMPORTANT: Not Required in Ideal scenario. But all scenarios are not idle everytime
  			me.freeTrialUser(false,false);
  		}

  		var products = [];
  		products.push(prodInfo);

  		var paramObj = {
  			"products":products
  		} 

  		new NativeAjax(this.getUrlFor("FREE_PRODUCT_CHECK"),paramObj).enableCORS().post(successFn,failureFn);
  	}else{
  		console.warn("productId or TariffId not available in prodInfo :", prodInfo);
  	}
  }

  loadProductDetails(productid){
  	var me = this;
  	var paramObj = { "productId":productid}
  	var callBackSuccess = function(response){	
  		console.log("response:::",response);
  		if(typeof response === "object" && response){
  			localStorage.setItem('product',response.product_order[0]); 
				//localStorage.setItem('grade',this.gradeNo);
				localStorage.setItem('proDetail',JSON.stringify(response.product_details));
				//me.setState({productsInfoAvailable:true});
				try{
					var tariffs = response.product_details[productid]["pricing_details"];
					if(tariffs){
						for(var i in tariffs){
							if(tariffs[i]["is_trial"] || tariffs[i]["is_free_product"]){
								me.checkUserFreeTrial({"productId":productid, "tariffId":i});
								break;
							}
						}
					}

				}catch(e){
					console.error(e);
				}
			}else{
				me.setState({productsLoadErr:true});
			}

		}

		var callBackFailure = function(response){		
			me.isProdcutLoadCalled = false;
			console.log("Error in PRODUCT_DETAILS");		
		}

		new NativeAjax(this.getUrlFor("PRODUCT_DETAILS"),paramObj).enableCORS().post(callBackSuccess,callBackFailure);
	}

	Home(){
		if(!this.tracked){
			this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"home-PageView"});
			this.tracked = true;
		}

		try{
			if(this.state.LumosloggedIn){
				window.location.href = this.getUrlFor("LUMOS_REDIRECT_URL");
			}else if(this.state.PLPloggedIn && !window.location.href.match("/home")){
				window.location.href = "/landing";
			}
		}catch(e){}

		this.selectedMenu = "menuhome";
		var me=this;
		return(
			<div>
			{me.setTitle("HOME_title")}
			{me.setMeta("HOME_meta")}
			{me.setHeading("HOME_heading")}
			<div id="bannerElement">{this.getBannerContent()}</div>
			<ScrollToTopOnMount/>
			<Banner products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()} grades={this.getGrades()} products_class={this.getProductsClass()} PLPloggedIn={this.state.PLPloggedIn} startFreeTrial={this.startFreeTrial} showSignUp={this.showSignUp} showNewLoginForm={this.showNewLoginForm}></Banner>
		{/*<LiveFeed PLPloggedIn={this.state.PLPloggedIn} showNewLoginForm={this.showLiveFeedLogin}/>*/}

		<RecognisedStatic></RecognisedStatic>
		<LessonFeatures></LessonFeatures>
	{/* <Experience products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Experience> */}
	<Why></Why>
{/* <OurParents></OurParents> */}
<OurTeachers></OurTeachers>
<OurTestimonial></OurTestimonial>
{/* <Testimonial></Testimonial> */}
<StaticFeed>

</StaticFeed>
{/* <Featured></Featured> */}
<SignupSection PLPloggedIn={this.state.PLPloggedIn} startFreeTrial={this.startFreeTrial} showSignUp={this.showSignUp} showNewLoginForm={this.showNewLoginForm}></SignupSection>
<Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
{this.fireMobileToast()}
</div>
);
}

Products({ match }){
	
	if(!this.tracked){
		this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"product-PageView"});
		this.tracked = true;
	}


	HmEventRegistry.fireEvent("INITIATE_GA");
	HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	this.selectedMenu = "menuproducts";
	var me=this;
	return(
	<div>
	{me.setTitle("PRODUCTS_title")}
	{me.setMeta("PRODUCTS_meta")}
	{me.setHeading("PRODUCTS_heading")}
	<ScrollToTopOnMount/>
	<PageBanner name={this.rb("header.label.products.tab")} classes="bg-grn"></PageBanner>
	<Trusted></Trusted>
	<Grades url={`${match.url}`} products_category={this.getProductsType()} grades={this.getGrades()} classes={this.getClasses()} products_class={this.getProductsClass()}></Grades>
	<Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()} grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
	{this.fireMobileToast()}
	</div>
	);
}
Learnings(){
	this.setTitle("LEARNINGS_title");

	HmEventRegistry.fireEvent("INITIATE_GA");
	HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	this.selectedMenu = "menuourlearnings";
	return(
	<div>
	<ScrollToTopOnMount/>
{/*<PageBanner name="Our Learnings" classes="bg-grn bg-blue banner-text" text={this.rb("our_learnings_heading")}></PageBanner>*/}
<PageBanner classes="bg-grn bg-blue banner-text" text={this.rb("our_learnings_heading")}></PageBanner>
<FlipSection></FlipSection>
<OtherLearnings></OtherLearnings>
<Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
</div>
);
}
SelfPaced({ match }){

	if(!this.tracked){
		this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"spl-PageView"});
		this.tracked = true;
	}

	HmEventRegistry.fireEvent("INITIATE_GA");
	HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	if(this.state.productsInfoAvailable && this.state.userProdReqComplete){
		return(
		<div>
		<ScrollToTopOnMount/>
		<PageBannerBuy name="Self-Paced Lessons" triedFree={this.state.triedFree} purchased={this.state.purchased} classes="bg-grn bg-blue-large banner-text" text="To build a strong conceptual foundation" id={`${match.params.id}`} showSubScripeLoginForm={this.showSubScripeLoginForm} productBase="plp" simpleform="true"></PageBannerBuy>
		<OverallFeatures name="SPL"></OverallFeatures>
		<Lessons id={`${match.params.id}`} PLPloggedIn={this.state.PLPloggedIn}></Lessons>

		<Topics id={`${match.params.id}`} productBase="selfpaced"></Topics>

		{(() => {
			if(!window.suppress_all_paid_products){
			return <BuyOption id={`${match.params.id}`} triedFree={this.state.triedFree} purchased={this.state.purchased} showSubScripeLoginForm={this.showSubScripeLoginForm} productBase="selfpaced" simpleform="false"></BuyOption>
			}
		})()}
				
		<Use imgName="../img/sgp.jpg" owner="spl"></Use>
		<Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
		</div>
		);
	}else{
		if(this.isProdcutLoadCalled == false){
			this.isProdcutLoadCalled = true;
			this.loadProductDetails(`${match.params.id}`);
		}

		if(this.state.productsLoadErr){
			return(
			<div>
			<ScrollToTopOnMount/>
			<ProductBanner name="Self-Paced Lessons" classes="bg-grn bg-blue banner-text" text="To build a strong conceptual foundation" bannerPoint1="Learn the Why"
			bannerPoint2="Know the How" bannerPoint3="Check your understanding"></ProductBanner>		
			<div className="text-center josefin mt-30"><h4> {this.rb("profile.oops")} </h4></div>
			</div>
			);	
		}else{
			return(
			<div>
			<ScrollToTopOnMount/>
			<ProductBanner name="Self-Paced Lessons" classes="bg-grn bg-blue banner-text" text="To build a strong conceptual foundation" bannerPoint1="Learn the Why"
			bannerPoint2="Know the How" bannerPoint3="Check your understanding"></ProductBanner>		
			<div className="productLoading"> {this.showLoader()} </div>
			</div>
			);	
		}
	}
}

Plp({ match }){

	if(!this.tracked){
		this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"plp-PageView"});
		this.tracked = true;
	}


	HmEventRegistry.fireEvent("INITIATE_GA");
	HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	if(this.state.productsInfoAvailable && this.state.userProdReqComplete){
		return(
		<div>
		<ScrollToTopOnMount/>		     
		<PageBannerBuy name="Personalised Learning" triedFree={this.state.triedFree} purchased={this.state.purchased} classes="bg-grn bg-grn-large banner-text" text={this.rb("PLP.build")} id={`${match.params.id}`} showSubScripeLoginForm={this.showSubScripeLoginForm} productBase="plp" simpleform="true"></PageBannerBuy>
		<DownloadButton id={`${match.params.id}`}></DownloadButton>
		<OverallFeatures name="PLP"></OverallFeatures>
	{/* <HowWorks></HowWorks> */}
	<Lessons id={`${match.params.id}`} PLPloggedIn={this.state.PLPloggedIn}></Lessons>

	<Topics id={`${match.params.id}`} productBase="plp"></Topics>
{/* <DownloadButton id={`${match.params.id}`} className={"download-mt"}></DownloadButton> */}

{(() => {
	if(!window.suppress_all_paid_products){
		return <BuyOption id={`${match.params.id}`} triedFree={this.state.triedFree} purchased={this.state.purchased} showSubScripeLoginForm={this.showSubScripeLoginForm} productBase="plp" simpleform="false"></BuyOption>
	}
})()}
<Use imgName="../img/pdbg.png" owner="plp"></Use>
<Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
</div>
);
}else{
	if(this.isProdcutLoadCalled == false){
		this.isProdcutLoadCalled = true;
		this.loadProductDetails(`${match.params.id}`);
	}

	if(this.state.productsLoadErr){
		return(
		<div>
		<ScrollToTopOnMount/>
		<PageBanner name="Personalised Learning" classes="bg-grn banner-text" text={this.rb("PLP.build")}></PageBanner>
		<div className="text-center josefin mt-30"><h4> {this.rb("profile.oops")} </h4></div>
		</div>
		);	
	}else{
		return(
		<div>
		<ScrollToTopOnMount/>
		<PageBanner name="Personalised Learning" classes="bg-grn banner-text" text={this.rb("PLP.build")}></PageBanner>
		<div className="productLoading"> {this.showLoader()} </div>
		</div>
		);	
	}
}
}


cbse({ match }){
	
	if(!this.tracked){
		this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"cbse-PageView"});
		this.tracked = true;
	}

	HmEventRegistry.fireEvent("INITIATE_GA");
	HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	if(this.state.productsInfoAvailable && this.state.userProdReqComplete){
		return(
		<div>
		<ScrollToTopOnMount/>
		<PageBannerBuy name="CBSE Exam Prep" triedFree={this.state.triedFree} purchased={this.state.purchased} classes="bg-grn bg-yellowbg banner-text" text="To achieve your best in the board exams" id={`${match.params.id}`} showSubScripeLoginForm={this.showSubScripeLoginForm} productBase="cbse" simpleform="true"></PageBannerBuy>
		<HowWorks></HowWorks>
		<Lessons id={`${match.params.id}`} PLPloggedIn={this.state.PLPloggedIn}></Lessons>

		<Topics id={`${match.params.id}`} productBase="cbse" imgName="../img/pdbg.png" owner="cbse"></Topics>

		{(() => {
			if(!window.suppress_all_paid_products){
			return <BuyOption id={`${match.params.id}`} triedFree={this.state.triedFree} purchased={this.state.purchased} showSubScripeLoginForm={this.showSubScripeLoginForm} productBase="cbse" simpleform="false"></BuyOption>
			}
		})()}
		
		<Use imgName="../img/pdbg.png" owner="cbse"></Use>
		<Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
		</div>
		);
	}else{
		if(this.isProdcutLoadCalled == false){
			this.isProdcutLoadCalled = true;
			this.loadProductDetails(`${match.params.id}`);
		}
		
		if(this.state.productsLoadErr){
			return(
			<div>
			<ScrollToTopOnMount/>
			<PageBanner name="CBSE Exam Prep" classes="bg-grn bg-yellowbg banner-text" text="To achieve your best in the board exams"></PageBanner>
			<div className="text-center josefin mt-30"><h4> {this.rb("profile.oops")} </h4></div>
			</div>
			);	
		}else{
			return(
			<div>
			<ScrollToTopOnMount/>
			<PageBanner name="CBSE Exam Prep" classes="bg-grn bg-yellowbg banner-text" text="To achieve your best in the board exams"></PageBanner>
			<div className="productLoading"> {this.showLoader()} </div>
			</div>
			);	
		}
	}
}

WhoWeAre(){
	HmEventRegistry.fireEvent("INITIATE_GA");
	HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	this.selectedMenu = "menuwhoweare";
	var me=this;
	return(
	<div>
	{me.setTitle("WHO_WE_ARE_title")}
	{me.setMeta("WHO_WE_ARE_meta")}
	{me.setHeading("WHO_WE_ARE_heading")}
	<ScrollToTopOnMount/>
	<WhoBanner></WhoBanner>
	<DayInLife></DayInLife>
	<Culture></Culture>
	<Founders></Founders>
	<OurTeam></OurTeam>
	<FounderVideos></FounderVideos>
{/*<ScholarsProgram></ScholarsProgram>*/}
<Recognised></Recognised>
<Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
</div>
);
}

Spotlight(){
	HmEventRegistry.fireEvent("INITIATE_GA");
	HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	this.selectedMenu = "menuspotlight";
	return(
	<div>

	<Spotlight showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Spotlight>
	</div>
	);
}

Teachers({ match }){ 
	HmEventRegistry.fireEvent("INITIATE_GA");
	HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	this.selectedMenu = "menuteachers";

	if(!this.tracked){
		this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"teacherpage"});
		this.tracked = true;
	}

	return(
	<div>
	<ScrollToTopOnMount/>
	<TeacherBannerBuy name="CBSE Exam Prep" showContactus={this.showContactusForTeacher} triedFree={this.state.triedFree} purchased={this.state.purchased} classes="bg-grn bg-yellowbg banner-text" text="To achieve your best in the board exams" id={`${match.params.id}`} showSubScripeLoginForm={this.showSubScripeLoginForm} productBase="cbse" simpleform="true"></TeacherBannerBuy>
{/* <EndorsedStatic></EndorsedStatic> */}
<ProgramHighlights></ProgramHighlights>
<TeacherProdComp showSubscriptionForm={this.showSubscriptionForm} postLoginCallBack={this.postLoginCallBack} ></TeacherProdComp>
<EndorsedStatic></EndorsedStatic>
<NrichCollaboration></NrichCollaboration>
<TeacherTestimonial></TeacherTestimonial>
<TeacherResources></TeacherResources>
<TeacherBuy showContactus={this.showContactusForTeacher}></TeacherBuy>
<Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
</div>
);
}

SGCatalogue({ match }){ 
	HmEventRegistry.fireEvent("INITIATE_GA");
	HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	this.selectedMenu = "sgproducts";

	if(!this.tracked){
		this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"teacherpage"});
		this.tracked = true;
	}

	return(
	<div>
	<ScrollToTopOnMount/>
	<TopBanner name="CBSE Exam Prep" showContactus={this.showContactusForTeacher} triedFree={this.state.triedFree} purchased={this.state.purchased} classes="bg-grn bg-yellowbg banner-text" text="To achieve your best in the board exams" id={`${match.params.id}`} showSubScripeLoginForm={this.showSubScripeLoginForm} productBase="cbse" simpleform="true" />
	<OverallFeatures name="PLP"></OverallFeatures>
	<SGProductCatalogue showSubscriptionForm={this.showSubscriptionForm} postLoginCallBack={this.postLoginCallBack} />
	<EndorsedStatic></EndorsedStatic>
	<NrichCollaboration></NrichCollaboration>
	{/*<SGTeacherBuy showContactus={this.showContactusForTeacher}></SGTeacherBuy>*/}
	<Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
	</div>
);
}

switchProdType(prodType){
	if(prodType){
		this.setState({catalogProdType:prodType});	
	}	
}

newINCatalogue({ match }){ 
	HmEventRegistry.fireEvent("INITIATE_GA");
	HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	this.selectedMenu = "menuproducts";

	if(!this.tracked){
		this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"teacherpage"});
		this.tracked = true;
	}

	return(
	<div>
	<ScrollToTopOnMount/>
	<InTopBanner key={this.state.catalogProdType} prodType={this.state.catalogProdType} name="CBSE Exam Prep" showContactus={this.showContactusForTeacher} triedFree={this.state.triedFree} purchased={this.state.purchased} classes="bg-grn bg-yellowbg banner-text" text="To achieve your best in the board exams" id={`${match.params.id}`} showSubScripeLoginForm={this.showSubScripeLoginForm} productBase="cbse" simpleform="true" />
	<OverallFeatures name={this.state.catalogProdType}></OverallFeatures>
	<NewINProductCatalogue switchProdType={this.switchProdType} showSubscriptionForm={this.showSubscriptionForm} postLoginCallBack={this.postLoginCallBack} />
	<EndorsedStatic></EndorsedStatic>
	<NrichCollaboration></NrichCollaboration>
	<Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
	</div>
);
}

Faq(){
	HmEventRegistry.fireEvent("INITIATE_GA");
	HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	//this.selectedMenu = "menufaq";
	return(
		<div>
		<FAQ/>
		<Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
		</div>
		);
}

Blog(){
	HmEventRegistry.fireEvent("INITIATE_GA");
	HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	this.selectedMenu = "menublog";
	return(
		<div>
		<Blog/>
	{/* <Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer> */}
	</div>
	);
}

GetProductDetails = ({ match }) => (
<div className="heyPrelolgin">
<BillingDetails myProps={this.props}  purchaseKey={this.state.purchaseKey} />
<Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
</div>
)
GetMyProducts = ({ match }) => (
<div className="heyPrelolgin">
<MyProducts myProps={this.props}  PLPloggedIn={this.state.PLPloggedIn} purchaseKey={this.state.purchaseKey} showSubScripeLoginForm={this.showSubScripeLoginForm}/>
<Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
</div>
)

GetMyProfile = ({ match }) => (
<div>
<ScrollToTopOnMount/>
<PageBanner name="My Profile" classes="bg-grn settingsbggren mt-0"></PageBanner>
<div className="container">
<Settings callbackHomeUpdateImage={this.UpdateProfileImage} userNameUpdateEvent={this.userNameUpdateEvent}/>	  	
<br />
</div>
</div>
)

productTab(){
	const me = this;
	if(this.isMobile() || this.isTab()){
		if(this.isHeaderMenuAllowed("my_products")){
			return(<li data-ga="Products - Main tab"><Link className="heyMenu menuproducts" data-classname="menuproducts" to="/in/products" onClick={this.menuSelected}>{this.rb("in.products.students.title")}</Link></li>
			)
		}
	}else{
		//return (this.renderClassView());
		return(
			<li data-ga="Products - Main tab"><Link className="heyMenu menuproducts" data-classname="menuproducts" to="/in/products" onClick={this.menuSelected}>{this.rb("in.products.students.title")}</Link></li>
		)
	}
}

sgProductTab(){
	const me = this;
	if(this.isMobile() || this.isTab()){
		//if(this.isHeaderMenuAllowed("sg_products")){
			return(
				<li data-ga="Products - Main tab"><Link className="heyMenu sgproducts" data-classname="sgproducts" to="/sg/products" onClick={this.menuSelected}>{this.rb("sg.products.title")}</Link></li>
			)
		//}
	}else{
		return(
			<li data-ga="Products - Main tab" ><Link className="heyMenu sgproducts" data-classname="sgproducts" to="/sg/products" onClick={this.menuSelected}>{this.rb("sg.products.title")}</Link></li>
	   )
	}
}

aboutUsTab(){
	if(!window.teachers_tab_suppressed && (this.isMobile() || this.isTab())){
		return(
			<li data-ga="Teachers - Main Tab" ><Link className="heyMenu menuteachers" data-classname="menuteachers" to="/teachers" onClick={this.menuSelected}>Teachers</Link></li>
		)
	}else{
		return(
		this.renderAboutUsMenu()
		)
	}
}

geoBasedProductHeader = () => {
	let me=this;
	if(this.prodForCountry() === 'IN'){
		return me.productTab();		
	}else if(this.prodForCountry() === 'SG'){
		return me.sgProductTab();
	}else{
		return (
			<Fragment>
				{me.productTab()}
				{me.sgProductTab()}
		</Fragment> )
		}
}


postLoginTchr(userObj){
	var me = this;
	if(!userObj){
		userObj = this.getUser().get();
	}

	let geoLocation = this.getGeo().toUpperCase() || '';

	 if(userObj && userObj.userRole && userObj.userRole.role && userObj.userRole.role.toUpperCase() === "TCHR" && geoLocation === "IN") {
			return (
				<ul className="textAlignLeft">
					<li data-ga="Teachers - Main Tab" ><Link className="heyMenu menuteachers" data-classname="menuteachers" to="/teachers" onClick={this.menuSelected}>Teachers</Link></li>
				</ul>	
			);
		}else{ 
			return (
				<ul className="textAlignLeft">
					{
						this.productTab()
						
					}
					{ this.sgProductTab() }
				</ul>
			);
		}
}
postLoginTchrTab(userObj){
	var me = this;
	if(!userObj){
		userObj = this.getUser().get();
	}

	let geoLocation = this.getGeo().toUpperCase() || '';
	 if(userObj && userObj.userRole && userObj.userRole.role && userObj.userRole.role.toUpperCase() === "TCHR" && geoLocation === "IN") {
			return (
				<ul className="textAlignLeft">
					<li data-ga="Teachers - Main Tab" ><Link className="heyMenu menuteachers" data-classname="menuteachers" to="/teachers" onClick={this.menuSelected}>Teachers</Link></li>
				</ul>	
			);
		}else{ 
			return (
				<ul className="textAlignLeft">
					{me.productTab()}
					{ this.sgProductTab() }
				</ul>
			);
		}
}

getSwitcher(){
	return(
	<Switch>
	<Redirect from="/" exact to="/in"/>		

	<Route exact path='/in' component={this.Home}  maintainScrollPosition={true}/>
	<Route exact path='/home' component={this.Home}  maintainScrollPosition={true}/>
	<Route path="/landing" exact component={Home} />
	<Route path="/dashboard" exact component={Dashboard} />
	<Route path="/settings" exact component={this.GetMyProfile}/>
	<Route path="/report" exact component={Report} />
{/* <Route path="/scorecard/:id" exact component={Scorecard} />  */}
<Route path="/scorecard/:id/:reset?" exact component={Scorecard} />

<Redirect from="/classes" exact to={"in/products"}/>
<Redirect from="/products" exact to={this.getGeo()+"/products"}/>

<Route path='/in/products' component={this.newINCatalogue}  maintainScrollPosition={true}/>
<Route exact path='/sg/products' component={this.SGCatalogue} maintainScrollPosition={true}/>  

<Route exact path='/in/oldproducts' component={this.Products} maintainScrollPosition={true}/>  	

<Route path='/our-learnings' component={this.Learnings} maintainScrollPosition={true}/>
<Route path='/who-we-are' component={this.WhoWeAre} maintainScrollPosition={true}/>
<Route path='/blog' component={this.Blog} maintainScrollPosition={true}/>
<Route path='/spotlight' component={this.Spotlight} maintainScrollPosition={true}/>
<Route path="/faq" component={this.Faq} maintainScrollPosition={true} />
<Route path='/self-learning/:id' component={this.SelfPaced} maintainScrollPosition={true}/>
<Route path='/personalised-learning/:id' component={this.Plp} maintainScrollPosition={true}/>
<Route path='/cbse-exam/:id' component={this.cbse} maintainScrollPosition={true}/>
<Route exact path='/product-details' component={this.GetProductDetails} maintainScrollPosition={true}/>
<Route exact path='/teachers' component={this.Teachers} maintainScrollPosition={true}/>

<Redirect from="/myproducts" to="/mysubscriptions"/>
<Route path="/mysubscriptions" exact component={this.GetMyProducts} maintainScrollPosition={true}/>
<Route exact path="/404" component={this.Home} />
<Route component={this.Home} />
<Redirect from='*' to='/' />
</Switch>
)
}

isHeaderMenuAllowed(headerMenu){
	if(headerMenu && window.header_suppression_for_school &&  window.header_suppression_for_school[this.getSchoolId()] && window.header_suppression_for_school[this.getSchoolId()].length > 0){
		this.suppressedHeaders = window.header_suppression_for_school[this.getSchoolId()] || [];
		return (this.suppressedHeaders.indexOf(headerMenu) === -1);
	}

	return true;
}

getHeaderLogo(){
	return(
		<img src="/img/h-logo.png" alt="Heymath! logo"/>
	)
}

geoBasedProdMobNav = () => {
	if(this.prodForCountry() === 'IN'){
		return(<span>
			<li data-ga="Products - Main tab" className="animated"><Link className="heyMenu menuproducts" data-classname="menuproducts" to="/products" onClick={() => this.menuSelected()}>{this.rb("in.products.students.title")}</Link></li>
			<li data-ga="SG Prducts - Main Tab" className="animated"><Link className="heyMenu menusgproducts" data-classname="menusgproducts" to="/sg/products" onClick={() => this.menuSelected()}>{this.rb("sg.products.title")}</Link></li>
			</span>
		)
	}else if(this.prodForCountry() === 'SG'){
		return(
			<li data-ga="SG Prducts - Main Tab" className="animated"><Link className="heyMenu menusgproducts" data-classname="menusgproducts" to="/sg/products" onClick={() => this.menuSelected()}>{this.rb("sg.products.title")}</Link></li>
		)
	}else{
		return(
			<Fragment>
				<li data-ga="Products - Main tab" className="animated"><Link className="heyMenu menuproducts" data-classname="menuproducts" to="/products" onClick={() => this.menuSelected()}>{this.rb("in.products.students.title")}</Link></li>
				<li data-ga="SG Prducts - Main Tab" className="animated"><Link className="heyMenu menusgproducts" data-classname="menusgproducts" to="/sg/products" onClick={() => this.menuSelected()}>{this.rb("sg.products.title")}</Link></li>
			</Fragment>
		)
	}
}

getRouter(){
	var me=this;

	return(
	<Router>
	<div>
	<header className="clearfix">
{/* <ContactHeader></ContactHeader> */}
<nav className="nav-desktop">
<div className="container-fluid norightpadding">
<div className="logo"><Link className="heyMenu menuhome" data-classname="menuhome" to="/home" onClick={me.setPreloginClass}>{this.getHeaderLogo()}</Link></div>


{( () => {
	if(me.state.LumosloggedIn){
		return (<ul className="textAlignLeft"><span></span></ul>);
	}else if(me.state.loggedIn || me.state.PLPloggedIn){
		return (			
			 <div>
				{(() => {
						if(me.isHeaderMenuAllowed("products")){
								return me.postLoginTchr();
						}else{
								return (<ul className="textAlignLeft"><span></span></ul>);                                        
						}
				})()}
			</div>
		);
	}else{
		return (
		<ul>
			<li data-ga="Home Tab" ><Link className="heyMenu menuhome" data-classname="menuhome" to="/" onClick={me.menuSelected}>Home</Link></li>
			{me.productTab()}
			{me.sgProductTab()}
			{(() =>{
				if(!window.teachers_tab_suppressed){
					return <li data-ga="Teachers - Main Tab" ><Link className="heyMenu menuteachers" data-classname="menuteachers" to="/teachers" onClick={this.menuSelected}>Teachers</Link></li>
				}
			})()}
			
			{me.aboutUsTab()}
		</ul>
	);
}
})()}


<div className="r-sec">
{(() => {
					if(me.isHeaderMenuAllowed("my_heymath")){
						return (<a data-ga="My HeyMath Tab" className={"r-btn myheymathbtn mr-30 "+me.getMargin()} onClick={me.showLoginForm}>{me.getButtonName()}</a>);
					}else{
						return (<ul className="textAlignLeft"><span></span></ul>);						
					}
				})()}

{me.renderLoginView()}                 	
</div>


</div>
</nav>

{
	(()=>{

		if(this.isHeaderMenuAllowed("hamburger")){

			return(
				<Menu right onStateChange={(state) => me.handleStateChange(state)} isOpen={me.state.menuOpen}>

<div id="menu-icon-wrapper" className="menu-icon-wrapper">
</div>

<nav className="nav-mobile">

{( () => {
	if(me.state.loggedIn && this.isHeaderMenuAllowed("hamburger")){
		return me.postLoginTchrTab();		
	}else if(this.isHeaderMenuAllowed("hamburger")){
		return (
		<ul>
		<li data-ga="Home Tab" className="animated"><Link className="heyMenu menuhome" data-classname="menuhome" to="/" onClick={() => this.menuSelected()}>Home</Link></li>
		
		<li data-ga="Products - Main tab" className="animated"><Link className="heyMenu menuproducts" data-classname="menuproducts" to="/products" onClick={() => this.menuSelected()}>{this.rb("in.products.students.title")}</Link></li>
		<li data-ga="SG Prducts - Main Tab" className="animated"><Link className="heyMenu menusgproducts" data-classname="menusgproducts" to="/sg/products" onClick={() => this.menuSelected()}>{this.rb("sg.products.title")}</Link></li>
		
		{(() =>{
			if(!window.teachers_tab_suppressed){
				return <li data-ga="Teachers - Main Tab" className="animated"><Link className="heyMenu menuteachers" data-classname="menuteachers" to="/teachers" onClick={() => this.menuSelected()}>Teachers</Link></li>
			}
		})()}
		
		<li data-ga="Our Learning - Main Tab" className="animated"><Link className="heyMenu menuourlearnings" data-classname="menuourlearnings" to="/our-learnings" onClick={() => this.menuSelected()}>Our Learnings</Link></li>   
	<li data-ga="Who we are - Main Tab" className="animated"><Link className="heyMenu menuwhoweare" data-classname="menuwhoweare" to="/who-we-are" onClick={() => this.menuSelected()}>Who We Are</Link></li>
{/* <li data-ga="Blog - Main Tab" className="animated"><Link className="heyMenu menublog" data-classname="menublog" to="/blog" onClick={() => this.menuSelected()}>Blog</Link></li> */}
<li data-ga="Spotlight - Main Tab" className="animated"><Link className="heyMenu menuspotlight" data-classname="menuspotlight" to="/spotlight" onClick={() => this.menuSelected()}>Spotlight</Link></li>
</ul>
);
}
})()}



</nav>
</Menu>
			)

		}else{
			return null;
		}

	})()
}



</header>
<div className="clearfix"></div>
{me.getSwitcher()}

</div>
</Router>
)
}

render() {
	HmEventRegistry.fireEvent("INITIATE_GA");
	HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	var isMenuOpen = function(state) {
		return state.isOpen;
	};
	const {grades,products_details,products_class,products_classification,products_category} = this.state;
	return (
	<div className={"App "+this.state.preloginClassName}>
	
	{this.getRouter()}
	<div>							
	<TestTakingModalComponent visible={this.state.ModalShow} dialogClassName={"loginModal modal-lg "+this.state.customClass}>

	<div data-p-ga="" className="modal-body">
	<div className="close loginClose" data-ga={this.modalcloseDataGA} onClick={this.hideLoginModal} aria-label="Close">
	<span aria-hidden="true"><i className="material-icons">close</i></span>
	</div>
	{this.state.ModalContent}
	</div>							
	</TestTakingModalComponent>
	</div>
	{/*
		<div>							
		<TestTakingModalComponent visible={this.state.ModalShow} dialogClassName={"loginModal modal-lg "+this.state.customClass}>
		<div className="loginHeader text-center">	
		<div className="text-center modallogo">
		{this.renderModalHeader()}
		</div>
		<div className="close loginClose" data-ga={this.modalcloseDataGA}  onClick={this.hideLoginModal} aria-label="Close">
		<span aria-hidden="true"><i className="material-icons">close</i></span>
		</div>
		</div>
		<div data-p-ga="" className="modal-body">
		{this.state.ModalContent}
		</div>							
		</TestTakingModalComponent>
		</div>
	*/}
	<div>							
	<TestTakingModalComponent visible={this.state.HelpModalShow} dialogClassName={"loginModal modal-lg "+this.state.customClass}>
	<div className="loginHeader text-center">	
	<div className="text-center modallogo">
	<div><div className="text-center loginHeaderTxt josefinsansFont">{this.rb("resetpwd.instruction")}</div></div>
	</div>
	<div className="close helpClose"  onClick={this.hideHelpLoginModal} aria-label="Close">
	<span aria-hidden="true"><i className="material-icons">close</i></span>
	</div>
	</div>
	<div className="modal-body">
	{this.state.HelpModalContent}
	</div>							
	</TestTakingModalComponent>
	</div>

	<div>							
		<TestTakingModalComponent visible={this.state.InfoModalShow} dialogClassName={"infoBanner loginModal modal-lg"}>
		<div className="infoHeader text-center">	
		<div className="text-center modallogo">
		{/* <div><div className="text-center loginHeaderTxt josefinsansFont">{this.state.InfoModalHeader}</div></div> */}
		</div>
		<div className="close helpClose"  onClick={this.hideInfoModal} aria-label="Close">
		<span aria-hidden="true"><i className="material-icons">close</i></span>
		</div>
		</div>
		<div className="modal-body" onClick={this.redirecttoSomewhere}>
		{ReactHtmlParser(this.state.InfoModalContent)}
		</div>							
		</TestTakingModalComponent>
	</div>

	{/*<div>
		<iframe className="hidden" src="https://testlumos.heymath.com/hmLoginForm.action" ref = {e => {
			this.logincontainer = e;
		}}></iframe>

		<iframe className="hidden" src="https://testlumos.heymath.com/forgotPasswordExternal.action" ref = {e => {
			this.forgotpwdcontainer = e;
		}}></iframe>
		</div>
	*/}

	</div>
	);
}
}


export default PreloginHome;

ComponentRegistry.register("in_PreloginHome",PreloginHome);
/**
* IMPORTANT: CommonPreLoginHome moved to sg_PreloginHome
*/
////ComponentRegistry.register("PreloginHome",PreloginHome);


// WEBPACK FOOTER //
// ./src/prelogin/src/PreloginHome.js